import { jsx as h } from "react/jsx-runtime";
import { useAutosizeTextArea as g } from "./useAutosizeTextArea.js";
import { usePreventNewline as v } from "./usePreventNewline.js";
import { useFocusEndOfText as y } from "./useFocusEndOfText.js";
import { cn as z } from "@deputy-ai/common";
import { cva as w } from "class-variance-authority";
import * as o from "react";
const P = o.forwardRef(
  (t, s) => {
    const {
      className: a,
      value: r,
      resize: i,
      autoSize: n,
      preventNewline: l = !1,
      onChange: u,
      onKeyDown: c,
      onFocus: d,
      ...p
    } = t, f = i ?? (n ? "none" : "vertical"), e = o.useRef(null);
    g(e, r, !n);
    const { onChange: m, onKeyDown: x } = v({
      enabled: l,
      elRef: e,
      onChange: u,
      onKeyDown: c
    }), { onFocus: b } = y({
      onFocus: d
    });
    return o.useImperativeHandle(s, () => e.current), /* @__PURE__ */ h(
      "textarea",
      {
        className: z(
          F.textarea({
            resize: f
          }),
          a
        ),
        ref: e,
        value: r,
        onChange: m,
        onKeyDown: x,
        onFocus: b,
        ...p
      }
    );
  }
);
P.displayName = "Textarea";
const F = {
  textarea: w(
    "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs placeholder:text-muted-foreground focus:border-transparent focus:outline-hidden focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 read-only:bg-primary-200",
    {
      variants: {
        resize: {
          none: "resize-none",
          vertical: "resize-y",
          horizontal: "resize-x",
          both: "resize-both"
        }
      }
    }
  )
};
export {
  P as Textarea
};
